import React, { Component, PropTypes } from 'react';
import Immutable from 'immutable';

import validationRegexes from 'constants/validationRegexes';

import { Field, FieldArray, reduxForm } from 'redux-form/immutable';

import FormInputWithValidation from 'components/Form/FormInputWithValidation';
import LinkButton from 'components/LinkButton/LinkButton';

import './EmailDeal.desktop.scss';
import './EmailDeal.mobile.scss';

export class EmailDeal extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    valid: PropTypes.bool.isRequired,
    isMobileBreakpoint: PropTypes.bool,
  };

  static validateRecipient = (values) => {
    let errors = Immutable.fromJS({});

    if (values && values.get('emailAddress', '') !== '') {
      if (!validationRegexes.email.test(values.get('emailAddress'))) {
        errors = errors.set('emailAddress', 'Invalid email address');
      }
    } else {
      errors = errors.set('emailAddress', 'Required');
    }

    if (values && values.get('name', '') === '') {
      errors = errors.set('name', 'Required');
    }

    if (values.has('recipients')) {
      errors = errors.set('recipients', values.get('recipients').map((recipient) => {
        let recipientErrors = Immutable.fromJS({});
        if (recipient.has('emailAddress')) {
          if (!validationRegexes.email.test(recipient.get('emailAddress'))) {
            recipientErrors = recipientErrors.set('emailAddress', 'Invalid email address');
          }

          if (!recipient.has('name')) {
            recipientErrors = recipientErrors.set('name', 'Required');
          }
        } else if (recipient.has('name')) {
          recipientErrors = recipientErrors.set('emailAddress', 'Required');
        }

        return recipientErrors;
      }));
    }

    return errors.toJS();
  };

  addRecipient = fields => (event) => {
    event.preventDefault();
    fields.push(Immutable.fromJS({}));
  };

  renderRecipients = ({ fields }) => (
    <div className="email-deal__additional-recipients">
      { fields.length > 0 && (
        <h4>Additional email addresses:</h4>
      )}
      {
        fields.map(recipient => (
          <div key={recipient} className="email-deal__additional-recipients__recipient">
            <Field name={`${recipient}.emailAddress`} component={FormInputWithValidation} type="text" placeholder="Email Address" />
            <Field name={`${recipient}.name`} component={FormInputWithValidation} type="text" placeholder="Name" />
          </div>
        ))
      }
      <LinkButton color="blue" type="secondary" onClick={this.addRecipient(fields)}>Add additional travellers</LinkButton>
    </div>
  );

  render() {
    const { isMobileBreakpoint } = this.props;
    return (
      <div className="email-deal">
        <form onSubmit={this.handleSubmit}>
          <h2>Email this deal</h2>
          <div className={`email-deal__sender ${!isMobileBreakpoint ? 'email-deal__sender--modal-view' : ''}`}>

            <h3 className="email-deal__sender__title">
              Your Contact Details
            </h3>
            <Field name="emailAddress" component={FormInputWithValidation} type="text" placeholder="Email Address" />
            <Field name="name" component={FormInputWithValidation} type="text" placeholder="Name" />

            <FieldArray name="recipients" component={this.renderRecipients} />

            <LinkButton color="blue" onClick={this.props.handleSubmit}>Send deal</LinkButton>
          </div>
        </form>
      </div>
    );
  }
}

const EmailDealForm = reduxForm({ form: 'email-deal', validate: EmailDeal.validateRecipient })(EmailDeal);
export default EmailDealForm;



/** WEBPACK FOOTER **
 ** ./src/components/EmailDeal/EmailDeal.jsx
 **/